"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'kaoqinUpload',
  components: {},
  data: function data() {
    return {
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      uploadUrl: '/api/CmsWorkOrderListController/uploadExcel',
      filePaths: [],
      fileList: [],
      workOrderNumber: ''
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'filesUploadApi'])),
  methods: {
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.filePaths.push(response);
      this.$emit('uploadSuccess', this.filePaths);
    },
    clearImgs: function clearImgs() {
      this.filePaths = [];
      this.fileList = [];
    }
  }
};
exports.default = _default;